import CMP from "./CMP.class";
import Utils from "./utils.class";
const { jQuery: $ } = window;

export default class Complianz extends CMP {
    constructor(theme, $body, readyCB = ()=>true) {
        super(theme, $body, readyCB)

        $(document).on("cmplz_status_change", (consentData) => this.#mapEvents(consentData));
    }

    load() {
        Utils.log("Loading Complianz Integration.");

        for(let i in this.types) {
            const type = this.types[i];

            if(window.themeSettings.debug || cmplz_has_consent(type)) {
                $(window).trigger(this.events.consent[type]);
            } else {
                $(window).trigger(this.events.denied[type]);
            }
        }
    }

    hasConsent(category) {
        return cmplz_has_consent(category);
    }

    open() {
        document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
            obj.click();
        });
    }

    #mapEvents(consentData) {
        const category = consentData.detail.category;

        if(cmplz_has_consent(category)) {
            $(window).trigger(this.events.consent[category]);
        } else {
            $(window).trigger(this.events.denied[category]);
        }
    }
}